export default __webpack_public_path__ + "static/media/zoko-water-mark.b024e360.svg";